import request from "@utils/request";

/**
 * 客户取消登记详情
 * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=210#6412
 */
export function postInfo(data) {
    return request({
        url: "/service/mg/cancel-register/info",
        method: "POST",
        data
    });
}
